/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_SERVER, API_SCT, API_UPLOADS } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(false);
    const [file, set_file] = useState(null);
    const [element, set_element] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [header_choose, set_header_choose] = useState('');

    const [title, set_title] = useState('');
    const [description, set_description] = useState('');

    const [title_slider, set_title_slider] = useState('');
    const [description_slider, set_description_slider] = useState('');

    const [address, set_address] = useState('');
    const [maps, set_maps] = useState('');
    const [credit, set_credit] = useState('');
    const [phone, set_phone] = useState('');
    const [email, set_email] = useState('');
    const [facebook, set_facebook] = useState('');
    const [twitter, set_twitter] = useState('');
    const [instagram, set_instagram] = useState('');
    const [youtube, set_youtube] = useState('');

    const [background, set_background] = useState('');
    const [video, set_video] = useState('');

    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (20 * pages) - 20 : 0
        
        }
        
        loading(true);

        API_GET_REQUEST('web__________?action=read_themes'
            + '&limit=20'
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_data(response.data.data)

                set_header_choose(response.data.data.setting[0].header);

                set_title(response.data.data.header_text[0].title);
                set_description(response.data.data.header_text[0].description);

                set_address(response.data.data.footer[0].address);
                set_maps(response.data.data.footer[0].map);
                set_credit(response.data.data.footer[0].credit);
                set_phone(response.data.data.footer[0].phone);
                set_email(response.data.data.footer[0].email);
                set_facebook(response.data.data.footer[0].facebook);
                set_twitter(response.data.data.footer[0].twitter);
                set_instagram(response.data.data.footer[0].instagram);
                set_youtube(response.data.data.footer[0].youtube);

                set_background(response.data.data.header[0].background);
                set_video(response.data.data.header_video[0].video);

			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {
        
        if(search.length > 3){
    
            API_GET_REQUEST('source__________?action=search'
                + '&search=' + search
            , 
            ).then((response) => {
                if(response.data.result == 'success'){
                    // console.log(JSON.stringify(response.data.data.list, undefined, 2))
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action, id) => {

        console.log('action : ', action)

        if(action !== 'text'){
            if(file === null){
                return error('Tidak ada file')
            }
        }
        
        // if(action !== 'footer'){
        //     if(file === null){
        //         return error('Tidak ada file')
        //     }
        // }

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("action", action);
        data.append("id", id);

        data.append("header_choose", header_choose);

        data.append("title", title);
        data.append("description", description);

        data.append("title_slider", title_slider);
        data.append("description_slider", description_slider);

        data.append("address", address);
        data.append("maps", maps);
        data.append("credit", credit);
        data.append("phone", phone);
        data.append("email", email);
        data.append("facebook", facebook);
        data.append("twitter", twitter);
        data.append("instagram", instagram);
        data.append("youtube", youtube);

        if(action !== 'text'){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_SERVER + "/api/v1.0/web/themes__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(action !== 'text'){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
                
                // if(action !== 'footer'){
                //     progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                // }
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('results : ', JSON.stringify(response.data));
                set_file(null)
                set_refresh(random_character(16))
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
            document.getElementById("background").value = "";
            document.getElementById("video").value = "";
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 10485760){
                return error('Ukuran File maxsimal 10MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read()
        }

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Web Themes</h1>
                </div>
            </div>
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian themes web</p>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Header Choose</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_relative">
                        <div onClick={() => {
                            if(element === 'overlay_dropdown'){
                                set_element(null)
                            }else{
                                set_element('overlay_dropdown')
                            }
                        }} className="_btn _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_column _capitalize">
                                    {header_choose}
                                </div>
                                <div className="_push_l_m _push_t_t">
                                    {
                                        element === 'overlay_dropdown' ?
                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                        :
                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            element === 'overlay_dropdown' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left">
                                        <div onClick={() => set_header_choose('background')} className="_item">Background</div>
                                        <div onClick={() => set_header_choose('slider')} className="_item">Slider</div>
                                        <div onClick={() => set_header_choose('video')} className="_item">Video</div>
                                        <div onClick={() => set_header_choose('gallery')} className="_item">Galley</div>
                                    </div>
                                </>
                            : null
                        }
                    </div>

                </div>
                <div>
                    <div onClick={() => {
                        _uploads('text')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Header Text</div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Title
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_title(e.target.value)}
                        value={title}
                    />
                </div>
            </div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_relative _push_b_m">
                        <p style={{color: '#888', fontSize: 13}}>
                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                            Description
                        </p>
                        <div className="_e_input">
                            <input 
                                placeholder=""
                                type={'text'} 
                                onChange={e => set_description(e.target.value)}
                                value={description}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        _uploads('text')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Background</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                            
                        <input
                            id="background"
                            className="custom-file-input" 
                            type="file"
                            name="file"
                            placeholder=""
                            onChange={_files}
                        />

                    </div>
                </div>
                <div>
                    
                    <div onClick={() => {
                        _uploads('background')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                    
                </div>
            </div>

            <div className="_push_b_d _push_t_d" style={{maxWidth: 600}}>
                {
                    background.length > 0 &&
                    <img src={API_SERVER + '/uploads/' + background} />
                }
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Slider</div>
            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <th>#</th>
                        <th>Image</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Action</th>
                    </thead>
                    <tbody>
                        {
                            data && data.header_slider_background.map((item, index) => (
                                <>
                                    <tr>
                                        <td>#{index + 1}</td>
                                        <td>
                                            <a href={API_UPLOADS + item.background}>
                                                <ion-icon name="image-outline" style={{fontSize: 24}}></ion-icon>
                                            </a>
                                        </td>
                                        <td>{item.title}</td>
                                        <td>{item.description}</td>
                                        <td className="_text_overflow">
                                            <div onClick={() => {
                                                if(element === `slider_${index}`){
                                                    set_element(null)
                                                }else{
                                                    set_element(`slider_${index}`)
                                                }
                                                set_title_slider(item.title)
                                                set_description_slider(item.description)
                                            }} className="_btn _push_r_m _cursor_pointer">
                                                Update
                                            </div>
                                        </td>
                                    </tr>

                                    {
                                        element === `slider_${index}` &&
                                        <tr>
                                            <td>#up</td>
                                            <td>
                                                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                                    
                                                    <input
                                                        id="video"
                                                        className="custom-file-input" 
                                                        type="file"
                                                        name="file"
                                                        placeholder=""
                                                        onChange={_files}
                                                    />
                            
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_title_slider(e.target.value)}
                                                            value={title_slider}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_description_slider(e.target.value)}
                                                            value={description_slider}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="_text_overflow">
                                                <div onClick={() => {
                                                    if(file !== null){
                                                        _uploads('slider', item.id)
                                                    }else{
                                                        _uploads('text', item.id)
                                                    }
                                                    set_element(null)
                                                }} className="_btn _push_r_m _cursor_pointer">
                                                    Submit
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Video</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                            
                        <input
                            id="video"
                            className="custom-file-input" 
                            type="file"
                            name="file"
                            placeholder=""
                            onChange={_files}
                        />

                    </div>
                </div>
                <div>
                    
                    <div onClick={() => {
                        _uploads('video')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                    
                </div>
            </div>
            
            {video.length > 0 &&
                <video className="_video_responsive" controls>
                    <source src={API_UPLOADS + video} type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
            }

            <div className="_font_size_20px _push_b_d _push_t_d">Footer</div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Address
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_address(e.target.value)}
                        value={address}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Maps
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_maps(e.target.value)}
                        value={maps}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Credit
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_credit(e.target.value)}
                        value={credit}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Phone
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_phone(e.target.value)}
                        value={phone}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Email
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_email(e.target.value)}
                        value={email}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Facebook
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_facebook(e.target.value)}
                        value={facebook}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Twitter
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_twitter(e.target.value)}
                        value={twitter}
                    />
                </div>
            </div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Instagram
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_instagram(e.target.value)}
                        value={instagram}
                    />
                </div>
            </div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_relative _push_b_m">
                        <p style={{color: '#888', fontSize: 13}}>
                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                            Youtube
                        </p>
                        <div className="_e_input">
                            <input 
                                placeholder=""
                                type={'text'} 
                                onChange={e => set_youtube(e.target.value)}
                                value={youtube}
                            />
                        </div>
                    </div>
                </div>
                <div style={{marginBottom: -20}}>
                    
                    <div onClick={() => {
                        _uploads('text')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                    
                </div>
            </div>

            {/* <div className="_row _center_align">
                <div className="_column">

                </div>
                <div className="_column">
                    
                </div>
            </div> */}

            {/* <div onClick={() => {
                if(element === 'overlay'){
                    set_element(null)
                }else{
                    set_element('overlay')
                }
            }} className="_btn _cursor_pointer">
                fmc overlay btn
            </div>

            {
                element === 'overlay' ?
                    <>
                        <div className="_fmc_overlay">
                            <div className="_fmc_overlay_navbar">
                                <div className="_row _center_align">
                                    <div className="_column">
                                        <p className="_font_size_18px">Overlay</p>
                                    </div>
                                    <div onClick={() => {
                                        if(element === 'overlay'){
                                            set_element(null)
                                        }else{
                                            set_element('overlay')
                                        }
                                    }} className="_push_l_d _btn _cursor_pointer">
                                        Keluar
                                    </div>
                                </div>
                            </div>
                            <div className="_fmc_overlay_content">

                            </div>
                        </div>
                    </>
                : null
            }

            <div className="_relative">
                <div onClick={() => {
                    if(element === 'overlay_dropdown'){
                        set_element(null)
                    }else{
                        set_element('overlay_dropdown')
                    }
                }} className="_btn _cursor_pointer">
                    <div className="_row _center_align">
                        <div className="_column">
                            fmc overlay dropdown btn
                        </div>
                        <div className="_push_l_m _push_t_t">
                            {
                                element === 'overlay_dropdown' ?
                                    <ion-icon name="chevron-up-outline"></ion-icon>
                                :
                                    <ion-icon name="chevron-down-outline"></ion-icon>
                            }
                        </div>
                    </div>
                </div>
                {
                    element === 'overlay_dropdown' ?
                        // _left or _right
                        <>
                            <div className="_fmc_overlay_dropdown _left">
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                            </div>
                        </>
                    : null
                }
            </div>

            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Input
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        // onChange={e => set_input(e.target.value)}
                        // value={input}
                    />
                </div>
            </div>

            <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                    
                <input
                    className="custom-file-input" 
                    type="file"
                    name="file"
                    placeholder=""
                    onChange={_files}
                />

            </div>

            <div onClick={() => {

            }} className="_btn _cursor_pointer">
                Simpan
            </div>

            <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari File" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div> */}

            <div style={{height: 100}}></div>

        </>
    );

}

export default Screen;